module.exports = __webpack_public_path__ + "integration-default.png";


//////////////////
// WEBPACK FOOTER
// ./images/integrations/integration-default.png
// module id = 1248
// module chunks = 74